import React from "react";
import { Button, Modal } from '@themesberg/react-bootstrap';

export default (props) => {

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ fontWeight: 'normal', fontSize: 15 }} id="contained-modal-title-vcenter">
          {props['title'] && props['title']}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0 d-flex justify-content-center align-items-center bg-dark" style={{ minHeight: '70vh' }}>
        <img 
          alt={props['title'] || 'Hình ảnh vé'} 
          src={props.image} 
          style={{ 
            maxWidth: '100%', 
            maxHeight: '70vh', 
            objectFit: 'contain',
            cursor: 'zoom-in'
          }}
          onClick={(e) => {
            if (e.target.style.objectFit === 'contain') {
              e.target.style.objectFit = 'scale-down';
              e.target.style.cursor = 'zoom-out';
            } else {
              e.target.style.objectFit = 'contain';
              e.target.style.cursor = 'zoom-in';
            }
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <a 
          href={props.image} 
          target="_blank" 
          rel="noopener noreferrer"
          className="btn btn-primary me-auto"
        >
          Mở tab mới
        </a>
        <Button variant="secondary" onClick={props.onHide}>Đóng</Button>
      </Modal.Footer>
    </Modal>
  );
}
